import React, { useEffect, useState } from "react";
import saveAs from "file-saver";
import axios from 'axios'; // npm i axios
import Navbar from '../NavbarPesquisaMineral/navbarPesquisamineral';
import Conexao from '../../Config/conexao';
import ListaDinamica_1RdoPesquisamineral from "./ListaDinamica_1RdoPesquisamineral";
import ListaDinamica_2RdoPesquisamineral from "./ListaDinamica_2RdoPesquisamineral"
import { excel } from "react-export-table-to-excel/lib/lib";
import { TryRounded } from "@mui/icons-material";
import SweetAlert from 'react-bootstrap-sweetalert';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import Select from 'react-select';
import moment from 'moment'
import VariavelGlobal from '../../Config/Variavelglobal'

//import '../RDO/Rdo.css'


function RDO_PesquisaMineral(props) {


    const [relatorioDObra, setRelatorioDObra] = useState("")
    const [clientes, setClientes] = useState([])
    const [clientes1, setClientes1] = useState([])
    const [datadordo, setDatadordo] = useState(Date)
    const [solicitante, setSolicitante] = useState("")
    const [escopo, setEscopo] = useState("")
    const [localizacao, setLocalizacao] = useState("")
    const [empresa, setEmpresa] = useState("")
    const [numeroContrato, setNumeroContrato] = useState("")
    const [propostocontrato, setPropostocontrato] = useState("")

    const [fiscal, setFiscal] = useState("")

    const [equipamento, setEquipamento] = useState("")
    const [tempomanha, setTempomanha] = useState("")
    const [tempotarde, setTempotarde] = useState("")
    const [temponoite, setTemponoite] = useState("")

    const [descricaoequipamento, setDescricaoequipamento] = useState("")
    const [quantidadeequipamento, setQuantidadeequipamento] = useState("")
    const [descricaoefetivo, setDescricaoefetivo] = useState("")
    const [quantidadeefetivo, setQuantidadeefetivo] = useState("")

    const [confirmacao, setConfirmacao] = useState(false);
    const [confirmacao1, setConfirmacao1] = useState(false);
    const [confirmacaoId, setConfirmacaoId] = useState('');
    const [confirmacaoId1, setConfirmacaoId1] = useState('');

    const [periodoInicio, setPeriodoInicio] = useState("")
    const [periodoFim, setPeriodoFim] = useState("")
    const [codigoAtividade, setCodigoAtividade] = useState("")
    const [descricaoAtividade, setDescricaoAtividade] = useState("")
    const [idtabela, setIdtabela] = useState("")
    const [quantidadeTabela, setQuantidadeTabela] = useState("")
    const [unidadeTabela, setUnidadeTabela] = useState("")
    const [observacaoTabela, setObservacaoTabela] = useState("")

    const [habilitar, setHabilitar] = useState(true)
    const [bnthabilitar, setBnthabilitar] = useState("true")

    const [setorLogado, setSetorLogado] = useState();
    const [setorDoCargo, setSetorDoCargo] = useState();
    const [nivelDoCargo, setNivelDoCargo] = useState();


    const [show, setShow] = useState(false);
    function handleClose() { setShow(false) }
    const handleShow = () => setShow(true);

    const [show1, setShow1] = useState(false);
    function handleClose1() { setShow1(false) }
    const handleShow1 = () => setShow1(true);

    function carregaUser() { setSetorLogado(localStorage.usuario) };
    useEffect(() => { carregaUser() }, []);

    async function getNivel() {
        const res = await axios.get(Conexao.api + 'BuscarVerificaSetorLogadoWEB.php? setorLogado=' + setorLogado);
        if (res.data.success === false) {
            //  setLoading(false)
            //  falha();  
        } else {

            if (res.data.nivel === "Gerente") {
                setHabilitar(false)
                setBnthabilitar(false)
                VariavelGlobal.ButtonEnable = false
                console.log("Nivel_Dentro  " + res.data.nivel);
                console.log("Usuario  " + setorLogado);
            } else {
                if (res.data.nivel === "Supervisor") {
                    setHabilitar(false)
                    setBnthabilitar(false)
                    VariavelGlobal.ButtonEnable = false
                } else {
                    setHabilitar(true)
                    setBnthabilitar(true)
                    VariavelGlobal.ButtonEnable = true
                }
            }

        }
    };

    function LIMPAR() {

        setSolicitante("")

        setDatadordo("")
        setSolicitante("")
        setEscopo("")
        setLocalizacao("")
        setEmpresa("")
        setPropostocontrato("")
    }


    const ListaDescricaoEquipamento = [
        { label: "Sonda Rotativa", value: 'Sonda Rotativa' },
        { label: "Trípe de Sondagem", value: 'Trípe de Sondagem' },
        { label: "Veiculo Administrativo", value: 'Veiculo Administrativo' },
        { label: "Caminhão Prancha", value: 'Caminhão Prancha' },
    ];

    const ListaDescricaoAtividade = [
        { label: "1-HORA PARADA - (CLIENTE) ACESSO BLOQUEADO / DESTRUÍDO / NÃO LIBERADO", value: 'HORA PARADA - (CLIENTE) ACESSO BLOQUEADO / DESTRUÍDO / NÃO LIBERADO' },
        { label: "2-HORA PARADA - (CLIENTE) EQUIPE PASSANDO POR TREINAMENTOS", value: 'HORA PARADA - (CLIENTE) EQUIPE PASSANDO POR TREINAMENTOS' },
        { label: "3-HORA PARADA - (CLIENTE) AGUARDANDO TOPOGRAFIA", value: 'HORA PARADA - (CLIENTE) AGUARDANDO TOPOGRAFIA' },
        { label: "4-HORA PARADA - (CLIENTE) INDEFINIÇÃO DE PROJETO", value: 'HORA PARADA - (CLIENTE) INDEFINIÇÃO DE PROJETO' },
        { label: "5-HORA PARADA-(CLIENTE) INSPEÇÃO DE SEGURANÇA", value: 'HORA PARADA-(CLIENTE) INSPEÇÃO DE SEGURANÇA' },
        { label: "6-HORA PARADA-(CLIENTE) LIBERAÇÃO DE PRAÇA DE SONDAGEM", value: 'HORA PARADA-(CLIENTE) LIBERAÇÃO DE PRAÇA DE SONDAGEM' },
        { label: "7-HORA PARADA-(CLIENTE) PIPA / ÁGUA", value: 'HORA PARADA-(CLIENTE) PIPA / ÁGUA' },
        { label: "8-HORA PARADA-(CLIENTE) AGUARDANDO LIBERAÇÃO DE MOBILIZAÇÃO", value: 'HORA PARADA-(CLIENTE) AGUARDANDO LIBERAÇÃO DE MOBILIZAÇÃO' },
        { label: "9-HORA PARADA-(CLIENTE) PRESENÇA DE ANIMAIS PEÇONHENTOS", value: 'HORA PARADA-(CLIENTE) PRESENÇA DE ANIMAIS PEÇONHENTOS' },
        { label: "10-HORA PARADA-(CLIENTE) NÃO FORNECIMENTO DE RÁDIOS OBRIGATÓRIOS", value: 'HORA PARADA-(CLIENTE) NÃO FORNECIMENTO DE RÁDIOS OBRIGATÓRIOS' },
        { label: "11-HORA PARADA-(CLIENTE) AGUARDANDO LIBERAÇÃO PARA INÍCIO DAS ATIVIDADES", value: 'HORA PARADA-(CLIENTE) AGUARDANDO LIBERAÇÃO PARA INÍCIO DAS ATIVIDADES' },
        { label: "12-HORA PARADA-(CLIENTE) OUTROS (NÃO USAR)", value: 'HORA PARADA-(CLIENTE) OUTROS (NÃO USAR)' },
        { label: "13-HORA PARADA-(CLIENTE) OUTROS (NÃO USAR)", value: 'HORA PARADA-(CLIENTE) OUTROS (NÃO USAR)' },
        { label: "14-HORA PARADA-(GEOCONTROLE) ATRASO NA MOBILIZAÇÃO", value: 'HORA PARADA-(GEOCONTROLE) ATRASO NA MOBILIZAÇÃO' },
        { label: "15-HORA PARADA-(GEOCONTROLE) AGUARDANDO ABASTECIMENTO", value: 'HORA PARADA-(GEOCONTROLE) AGUARDANDO ABASTECIMENTO' },
        { label: "16-HORA PARADA-(GEOCONTROLE) AGUARDANDO TRANSPORTE / PRANCHA PARA MUDANÇA", value: 'HORA PARADA-(GEOCONTROLE) AGUARDANDO TRANSPORTE / PRANCHA PARA MUDANÇA' },
        { label: "17-HORA PARADA-(GEOCONTROLE) AGUARDANDO DEFINIÇÃO DA SUPERVISÃO", value: 'HORA PARADA-(GEOCONTROLE) AGUARDANDO DEFINIÇÃO DA SUPERVISÃO' },
        { label: "18-HORA PARADA-(GEOCONTROLE) INSPEÇÃO / ORGANIZAÇÃO / REUNIÃO SEGURANÇA", value: 'HORA PARADA-(GEOCONTROLE) INSPEÇÃO / ORGANIZAÇÃO / REUNIÃO SEGURANÇA' },
        { label: "19-HORA PARADA-(GEOCONTROLE) MAT. / COROA / HASTES / REVEST. / ACESSÓRIOS", value: 'HORA PARADA-(GEOCONTROLE) MAT. / COROA / HASTES / REVEST. / ACESSÓRIOS' },
        { label: "20-HORA PARADA-(GEOCONTROLE) PESSOAL / TRAJETO", value: '20-HORA PARADA-(GEOCONTROLE) PESSOAL / TRAJETO' },

        { label: "21-HORA PARADA-(GEOCONTROLE) PIPA / ÁGUA", value: 'HORA PARADA-(GEOCONTROLE) PIPA / ÁGUA' },
        { label: "22-HORA PARADA - (GEOCONTROLE) VEÍCULO DE APOIO EM MANUTENÇÃO", value: 'HORA PARADA - (GEOCONTROLE) VEÍCULO DE APOIO EM MANUTENÇÃO ' },
        { label: "23-HORA PARADA - (GEOCONTROLE) EQUIPE FAZENDO EXAMES INTERNOS", value: 'HORA PARADA - (GEOCONTROLE) EQUIPE FAZENDO EXAMES INTERNOS ' },
        { label: "24-HORA PARADA - (GEOCONTROLE) EQUIPE AFASTADA POR RAZÕES DE SAÚDE", value: 'HORA PARADA - (GEOCONTROLE) EQUIPE AFASTADA POR RAZÕES DE SAÚDE' },
        { label: "25-HORA PARADA - (GEOCONTROLE) EQUIPE INDISPONÍVEL", value: 'HORA PARADA - (GEOCONTROLE) EQUIPE INDISPONÍVEL' },
        { label: "26-HORA PARADA - OUTROS(NÃO USAR)", value: 'HORA PARADA - OUTROS(NÃO USAR)' },
        { label: "27-HORA PARADA - (GEOCONTROLE) DEFEITO EM BOMBA DE LINHA DE ÁGUA", value: 'HORA PARADA - (GEOCONTROLE) DEFEITO EM BOMBA DE LINHA DE ÁGUA' },
        { label: "28-HORA PARADA - CHUVA / ALERTA DE RAIOS / CONDIÇÕES CLIMÁTICAS ADVERSAS", value: 'HORA PARADA - CHUVA / ALERTA DE RAIOS / CONDIÇÕES CLIMÁTICAS ADVERSAS' },
        { label: "29-HORA PARADA - OUTROS(NÃO USAR)", value: ' HORA PARADA - OUTROS(NÃO USAR)' },

        { label: "30-HORA PARADA - OUTROS(NÃO USAR)", value: 'HORA PARADA - OUTROS(NÃO USAR)' },
        { label: "31-HORA PARADA - OUTROS(NÃO USAR)", value: 'HORA PARADA - OUTROS(NÃO USAR)' },
        { label: "32-HORA PARADA - OUTROS(NÃO USAR)", value: 'HORA PARADA - OUTROS(NÃO USAR)' },
        { label: "33-DDS", value: 'DDS' },
        { label: "34-CHECKLIST", value: 'CHECKLIST' },
        { label: "35-REFEIÇÃO - ALMOÇO / JANTA", value: 'REFEIÇÃO - ALMOÇO / JANTA' },
        { label: "36-ABASTECENDO A SONDA", value: 'ABASTECENDO A SONDA' },
        { label: "37-DESLOCAMENTO DE EQUIPAMENTO / MUDANDO PRAÇA DE LOCAL", value: 'DESLOCAMENTO DE EQUIPAMENTO / MUDANDO PRAÇA DE LOCAL' },
        { label: "38-ORGANIZAÇÃO DE PRAÇA DE SONDAGEM", value: 'ORGANIZAÇÃO DE PRAÇA DE SONDAGEM' },
        { label: "39-CARREGANDO / DESCARREGANDO SONDA OU EQUIPAMENTO", value: 'CARREGANDO / DESCARREGANDO SONDA OU EQUIPAMENTO' },
        { label: "40-ORGANIZANDO MATERIAIS E INSUMOS DIVERSOS - GALPÃO / CAMPO / ESCRITÓRIO", value: 'ORGANIZANDO MATERIAIS E INSUMOS DIVERSOS - GALPÃO / CAMPO / ESCRITÓRIO' },
        { label: "40-MONTANDO LINHA DE ÁGUA", value: 'MONTANDO LINHA DE ÁGUA' },
        { label: "41-TRANSPORTANDO CAIXAS DE TESTEMUNHO", value: 'TRANSPORTANDO CAIXAS DE TESTEMUNHO ' },
        { label: "42-ENSAIO DE INFILTRAÇÃO EM SOLOS (LEFRANC)", value: 'ENSAIO DE INFILTRAÇÃO EM SOLOS (LEFRANC) ' },
        { label: "43-ENSAIO DE PERMEABILIDADE EM ROCHAS (LUGEON)", value: 'ENSAIO DE PERMEABILIDADE EM ROCHAS (LUGEON) ' },
        { label: "44-ENSAIO DE VANE TEST", value: 'ENSAIO DE VANE TEST" ' },
        { label: "45-ENSAIO PRESSIOMÉTRICO", value: 'ENSAIO PRESSIOMÉTRICO ' },
        { label: "46-CALIBRAÇÃO DO PRESSIÔMETRO", value: 'CALIBRAÇÃO DO PRESSIÔMETRO ' },
        { label: "47-OUTROS ENSAIOS (NÃO USAR)", value: 'OUTROS ENSAIOS (NÃO USAR) ' },
        { label: "48-OUTROS ENSAIOS (NÃO USAR)", value: 'OUTROS ENSAIOS (NÃO USAR) ' },
        { label: "49-OUTROS ENSAIOS (NÃO USAR)", value: 'OUTROS ENSAIOS (NÃO USAR) ' },
        { label: "50-INSTRUMENTAÇÃO - INSTALAÇÃO DE INA", value: 'INSTRUMENTAÇÃO - INSTALAÇÃO DE INA ' },
        { label: "51-INSTRUMENTAÇÃO - INSTALAÇÃO DE PIEZÔMETRO", value: 'INSTRUMENTAÇÃO - INSTALAÇÃO DE PIEZÔMETRO ' },
        { label: "52-INSTRUMENTAÇÃO - INSTALAÇÃO DE INCLINÔMETRO", value: 'INSTRUMENTAÇÃO - INSTALAÇÃO DE INCLINÔMETRO ' },
        { label: "53-TESTE DE VIDA EM INSTRUMENTOS - (INA / PZ)", value: 'TESTE DE VIDA EM INSTRUMENTOS - (INA / PZ) ' },
        { label: "54-PREPARAÇÃO DE TUBOS / TELA / BASE (INA / PZ / INCLINÔMETRO)", value: 'PREPARAÇÃO DE TUBOS / TELA / BASE (INA / PZ / INCLINÔMETRO) ' },
        { label: "55-OUTRAS ATIVIDADES", value: 'OUTRAS ATIVIDADES ' },
        { label: "56-OUTRAS ATIVIDADES", value: 'OUTRAS ATIVIDADES ' },
        { label: "57-OUTRAS ATIVIDADES", value: 'OUTRAS ATIVIDADES ' },
        { label: "58-AMOSTRAGEM - DEFORMADA", value: 'AMOSTRAGEM - DEFORMADA ' },
        { label: "60-AMOSTRAGEM - INDEFORMADAS (BLOCO (EQUIPE DA SONDA))", value: 'AMOSTRAGEM - INDEFORMADAS (BLOCO (EQUIPE DA SONDA)) ' },
        { label: "61-AMOSTRAGEM - INDEFORMADAS (DENISON / SHELBY / PROCTOR)", value: 'AMOSTRAGEM - INDEFORMADAS (DENISON / SHELBY / PROCTOR) ' },
        { label: "62-AMOSTRAGEM - BLOCOS DE ROCHA", value: 'AMOSTRAGEM - BLOCOS DE ROCHA ' },
        { label: "63-OUTRAS ATIVIDADES (NÃO USAR)", value: 'OUTRAS ATIVIDADES (NÃO USAR) ' },
        { label: "64-OUTRAS ATIVIDADES (NÃO USAR)", value: 'OUTRAS ATIVIDADES (NÃO USAR) ' },
        { label: "65-OUTRAS ATIVIDADES (NÃO USAR)", value: 'OUTRAS ATIVIDADES (NÃO USAR) ' },
        { label: "66-OUTRAS ATIVIDADES (NÃO USAR)", value: 'OUTRAS ATIVIDADES (NÃO USAR) ' },
        { label: "67-SONDAGEM - CRAVANDO REVESTIMENTO", value: '-SONDAGEM - CRAVANDO REVESTIMENTO ' },
        { label: "68-SONDAGEM - DESTRANCANDO FURO", value: 'SONDAGEM - DESTRANCANDO FURO ' },
        { label: "69-SONDAGEM - RECORTANDO FURO", value: 'SONDAGEM - RECORTANDO FURO ' },
        { label: "70-SONDAGEM - SACANDO FERRAMENTAS", value: 'SONDAGEM - SACANDO FERRAMENTAS ' },
        { label: "71-SONDAGEM - TROCANDO COROA / SAPATA", value: 'SONDAGEM - TROCANDO COROA / SAPATA ' },
        { label: "72-SONDAGEM À PERCUSSÃO", value: 'SONDAGEM À PERCUSSÃO ' },
        { label: "73-SONDAGEM DESTRUTIVA", value: 'SONDAGEM DESTRUTIVA ' },
        { label: "74-SONDAGEM MISTA", value: 'SONDAGEM DESTRUTIVA ' },
        { label: "75-SONDAGEM ROTATIVA", value: 'SONDAGEM ROTATIVA ' },
        { label: "76-SONDAGEM A TRADO", value: 'SONDAGEM A TRADO ' },
        { label: "77-TAMPONAMENTO FURO", value: 'TAMPONAMENTO FURO ' },
        { label: "78-LAVANDO FURO", value: 'LAVANDO FURO ' },
        { label: "79-OUTRAS ATIVIDADES DE PERFURAÇÃO (NÃO USAR)", value: 'OUTRAS ATIVIDADES DE PERFURAÇÃO (NÃO USAR) ' },
        { label: "80-OUTRAS ATIVIDADES DE PERFURAÇÃO (NÃO USAR)", value: 'OUTRAS ATIVIDADES DE PERFURAÇÃO (NÃO USAR) ' },
        { label: "81-OUTRAS ATIVIDADES DE PERFURAÇÃO (NÃO USAR)", value: 'OUTRAS ATIVIDADES DE PERFURAÇÃO (NÃO USAR) ' },
        { label: "82-OUTRAS ATIVIDADES DE PERFURAÇÃO (NÃO USAR)", value: 'OUTRAS ATIVIDADES DE PERFURAÇÃO (NÃO USAR) ' },
        { label: "83-CPTU - CRAVANDO HASTES", value: 'CPTU - CRAVANDO HASTES ' },
        { label: "84-CPTU - ANCORANDO EQUIPAMENTO", value: 'CPTU - ANCORANDO EQUIPAMENTO ' },
        { label: "85-CPTU - ENSAIO DE DISSIPAÇÃO", value: 'CPTU - ENSAIO DE DISSIPAÇÃO ' },
        { label: "86-CPTU - ENSAIO SÌSMICO", value: 'CPTU - ENSAIO SÌSMICO ' },
        { label: "87-CPTU - SATURANDO FURO COM ÁGUA", value: 'CPTU - SATURANDO FURO COM ÁGUA ' },
        { label: "88-CPTU - EXECUTANDO PRÉ-FURO", value: 'CPTU - EXECUTANDO PRÉ-FURO ' },
        { label: "89-OUTRAS ATIVIDADES DE CPTU (NÃO USAR)", value: 'OUTRAS ATIVIDADES DE CPTU (NÃO USAR) ' },
        { label: "90-OUTRAS ATIVIDADES DE CPTU (NÃO USAR)", value: 'OUTRAS ATIVIDADES DE CPTU (NÃO USAR) ' },
        { label: "91-OUTRAS ATIVIDADES DE CPTU (NÃO USAR)", value: 'OUTRAS ATIVIDADES DE CPTU (NÃO USAR) ' },
        { label: "92-OUTRAS ATIVIDADES DE CPTU (NÃO USAR)", value: 'OUTRAS ATIVIDADES DE CPTU (NÃO USAR) ' },
        { label: "93-OUTROS -  (NÃO USAR)", value: 'OUTROS -  (NÃO USAR) ' },
        { label: "94-OUTROS -  (NÃO USAR)", value: 'OUTROS -  (NÃO USAR) ' },
        { label: "95-OUTROS -  (NÃO USAR)", value: 'OUTROS -  (NÃO USAR) ' },
        { label: "96-MOBILIZAÇÃO", value: 'MOBILIZAÇÃO ' },
        { label: "97-DESMOBILIZAÇÃO", value: 'DESMOBILIZAÇÃO ' },
        { label: "98-FERIADO", value: 'FERIADO ' },
        { label: "99-FOLGA COLETIVA", value: 'FOLGA COLETIVA ' },
        { label: "100-FINAL DE SEMANA - SEM ATIVIDADES", value: 'FINAL DE SEMANA - SEM ATIVIDADES ' },
        { label: "101-AGUARDANDO MECÂNICO", value: 'AGUARDANDO MECÂNICO ' },
        { label: "102-AGUARDANDO PEÇAS", value: 'AGUARDANDO PEÇAS ' },
        { label: "103-DEFEITO ALTERNADOR / BATERIA", value: 'DEFEITO ALTERNADOR / BATERIA ' },
        { label: "104-DEFEITO BOMBA DE ÁGUA", value: 'DEFEITO BOMBA DE ÁGUA ' },
        { label: "105-DEFEITO BOMBA HIDRÁULICA", value: 'DEFEITO BOMBA HIDRÁULICA ' },
        { label: "106-DEFEITO BOMBA INJETORA", value: 'DEFEITO BOMBA INJETORA ' },
        { label: "107-DEFEITO CABEÇOTE / FUSO", value: 'DEFEITO CABEÇOTE / FUSO ' },
        { label: "108-DEFEITO CÂMBIO / CARDAN", value: 'DEFEITO CÂMBIO / CARDAN ' },
        { label: "109-DEFEITO CILINDRO / PISTÃO HIDRÁULICO", value: 'DEFEITO CILINDRO / PISTÃO HIDRÁULICO ' },
        { label: "110-DEFEITO COMANDO HIDRÁULICO", value: 'DEFEITO COMANDO HIDRÁULICO ' },
        { label: "111-DEFEITO GUINCHO / FREIOS", value: 'DEFEITO GUINCHO / FREIOS ' },
        { label: "112-DEFEITO MANDRIL HIDRÁULICO / MECÂ", value: 'DEFEITO MANDRIL HIDRÁULICO / MECÂ ' },
        { label: "113-DEFEITO MOTOR BOMBAS", value: 'DEFEITO MOTOR BOMBAS ' },
        { label: "114-DEFEITO MOTOR DA SONDA / RADIADOR", value: 'DEFEITO MOTOR DA SONDA / RADIADOR ' },
        { label: "115-DEFEITO MOTOR DE PARTIDA", value: 'DEFEITO MOTOR DE PARTIDA ' },
        { label: "116-DEFEITO NA CABEÇA D'ÁGUA", value: 'DEFEITO NA CABEÇA D ÁGUA ' },
        { label: "117-DEFEITO NO BYPASS", value: 'DEFEITO NO BYPASS ' },
        { label: "118-DEFEITO NO CABO PRINCIPAL", value: 'DEFEITO NO CABO PRINCIPAL ' },
        { label: "119-DEFEITO NO SENSOR DE FIM DE CURSO", value: 'DEFEITO NO SENSOR DE FIM DE CURSO ' },
        { label: "120-DEFEITO PINHÃO / COROA / TRANSMISSÃO", value: 'DEFEITO PINHÃO / COROA / TRANSMISSÃO ' },
        { label: "121-DEFEITO SISTEMA WIRELINE", value: 'DEFEITO SISTEMA WIRELINE ' },
        { label: "122-DEFEITO TORRE / CHASSIS / ROLDANAS", value: 'DEFEITO TORRE / CHASSIS / ROLDANAS ' },
        { label: "123-LIMPANDO EQUIPAMENTO", value: 'LIMPANDO EQUIPAMENTO ' },
        { label: "124-LUBRIFICAÇÃO / ABASTECIMENTO", value: 'LUBRIFICAÇÃO / ABASTECIMENTO ' },
        { label: "125-MANUTENÇÃO PREVENTIVA", value: 'MANUTENÇÃO PREVENTIVA ' },
        { label: "126-SONDA EM PANE GERAL", value: 'SONDA EM PANE GERAL ' },
        { label: "127-SUBS. CORREIAIS / MANGUEIRAS / FILTROS", value: 'SUBS. CORREIAIS / MANGUEIRAS / FILTROS ' },
        { label: "128-SUBS. INSTRUMENTOS / MANÔMETROS", value: 'SUBS. INSTRUMENTOS / MANÔMETROS ' },
        { label: "129-VAZAMENTOS", value: 'VAZAMENTOS ' },
        { label: "130-CAMISA TRAVADA NO BARRILETE", value: 'CAMISA TRAVADA NO BARRILETE ' },
        { label: "131-DEFEITO NO SISTEMA DE ESTEIRAS", value: 'DEFEITO NO SISTEMA DE ESTEIRAS ' },
        { label: "132-MANGUEIRAS HIDRÁULICAS ESTOURANDO", value: 'MANGUEIRAS HIDRÁULICAS ESTOURANDO ' },
        { label: "133-DEFEITO NO SISTEMA DE MORSAS", value: 'DEFEITO NO SISTEMA DE MORSAS ' },
        { label: "134-OUTROS - ", value: 'OUTROS  ' },
        { label: "135-OUTROS - ", value: 'OUTROS  ' },
        { label: "136-OUTROS - ", value: 'OUTROS  ' },
        { label: "137-OUTROS - ", value: 'OUTROS  ' },
        { label: "138-OUTROS - ", value: 'OUTROS  ' },
        { label: "139-OUTROS - ", value: 'OUTROS  ' },
        { label: "140-OUTROS - ", value: 'OUTROS  ' },
        { label: "141-OUTROS - ", value: 'OUTROS  ' },
        { label: "142-OUTROS - ", value: 'OUTROS  ' },
        { label: "143-OUTROS - ", value: 'OUTROS  ' },
        { label: "144-OUTROS - ", value: 'OUTROS  ' },
        { label: "145-OUTROS - ", value: 'OUTROS  ' },
        { label: "146-OUTROS - ", value: 'OUTROS  ' },
        { label: "147-OUTROS - ", value: 'OUTROS  ' },
        { label: "148-OUTROS - ", value: 'OUTROS  ' },
        { label: "149-OUTROS - ", value: 'OUTROS  ' },
        { label: "150-OUTROS - ", value: 'OUTROS  ' },
        { label: "151-OUTROS - ", value: 'OUTROS  ' },
        { label: "152-OUTROS - ", value: 'OUTROS  ' },
        { label: "153-OUTROS - ", value: 'OUTROS  ' },
        { label: "154-OUTROS - ", value: 'OUTROS  ' },
        { label: "155-OUTROS - ", value: 'OUTROS  ' },
        { label: "156-OUTROS - ", value: 'OUTROS  ' },
        { label: "157-OUTROS - ", value: 'OUTROS  ' },
        { label: "158-OUTROS - ", value: 'OUTROS  ' },
        { label: "159-OUTROS - ", value: 'OUTROS  ' },
        { label: "160-OUTROS - ", value: 'OUTROS  ' },
        { label: "161-OUTROS - ", value: 'OUTROS  ' },
        { label: "162-OUTROS - ", value: 'OUTROS  ' },
        { label: "163-OUTROS - ", value: 'OUTROS  ' },
        { label: "164-OUTROS - ", value: 'OUTROS  ' },
        { label: "165-OUTROS - ", value: 'OUTROS  ' },
        { label: "166-OUTROS - ", value: 'OUTROS  ' },
        { label: "167-OUTROS - ", value: 'OUTROS  ' },
        { label: "168-OUTROS - ", value: 'OUTROS  ' },
        { label: "169-OUTROS - ", value: 'OUTROS  ' },
        { label: "170-OUTROS - ", value: 'OUTROS  ' },
        { label: "171-OUTROS - ", value: 'OUTROS  ' },
        { label: "172-OUTROS - ", value: 'OUTROS  ' },
        { label: "173-OUTROS - ", value: 'OUTROS  ' },
        { label: "174-OUTROS - ", value: 'OUTROS  ' },
        { label: "175-OUTROS - ", value: 'OUTROS  ' },
        { label: "176-OUTROS - ", value: 'OUTROS  ' },
        { label: "177-OUTROS - ", value: 'OUTROS  ' },
        { label: "178-OUTROS - ", value: 'OUTROS  ' },
        { label: "179-OUTROS - ", value: 'OUTROS  ' },
        { label: "180-OUTROS - ", value: 'OUTROS  ' },
        { label: "181-OUTROS - ", value: 'OUTROS  ' },
        { label: "182-OUTROS - ", value: 'OUTROS  ' },
        { label: "183-OUTROS - ", value: 'OUTROS  ' },
        { label: "184-OUTROS - ", value: 'OUTROS  ' },
        { label: "185-OUTROS - ", value: 'OUTROS  ' },
        { label: "186-OUTROS - ", value: 'OUTROS  ' },
        { label: "187-OUTROS - ", value: 'OUTROS  ' },
        { label: "188-OUTROS - ", value: 'OUTROS  ' },
        { label: "189-OUTROS - ", value: 'OUTROS  ' },
        { label: "190-OUTROS - ", value: 'OUTROS  ' },
        { label: "191-OUTROS - ", value: 'OUTROS  ' },
        { label: "192-OUTROS - ", value: 'OUTROS  ' },
        { label: "193-OUTROS - ", value: 'OUTROS  ' },
        { label: "194-OUTROS - ", value: 'OUTROS  ' },
        { label: "195-OUTROS - ", value: 'OUTROS  ' },
        { label: "196-OUTROS - ", value: 'OUTROS  ' },
        { label: "197-OUTROS - ", value: 'OUTROS  ' },
        { label: "198-OUTROS - ", value: 'OUTROS  ' },
        { label: "199-OUTROS - ", value: 'OUTROS  ' },
        { label: "200-OUTROS - ", value: 'OUTROS  ' },
    ];

    const ListasdescricaoEfetivo = [
        { label: "Técnico Mineração", value: 'Técnico Mineração' },
        { label: "Laboratorista", value: 'Laboratorista' },


    ];

    async function BuscarRdo() {
        console.log('buscaRDO', relatorioDObra)
        const res = await axios.get(Conexao.api + 'ListaRdoWeb.php?relatorioDObra=' + relatorioDObra);


        if (res.data.success === true) {
            setSolicitante(res.data.result[0].solicitante)
            setEscopo(res.data.result[0].escopo)
            setLocalizacao(res.data.result[0].localizacao)
            setEmpresa(res.data.result[0].empresa)
            setNumeroContrato(res.data.result[0].numeroContrato)
            setPropostocontrato(res.data.result[0].propostocontrato)
            setFiscal(res.data.result[0].fiscal)
            setDatadordo(res.data.result[0].datadordo)
            setEquipamento(res.data.result[0].equipamento)
            setTempomanha(res.data.result[0].tempomanha)
            setTempotarde(res.data.result[0].tempotarde)
            setTemponoite(res.data.result[0].temponoite)

            setHabilitar(false)
            setBnthabilitar(false)
            VariavelGlobal.ButtonEnable = false
            getNivel()

        } else {

            VariavelGlobal.ButtonEnable = true
            LIMPAR()
            setHabilitar(true)
            setBnthabilitar(true)

            alert('RDO NÃO REALIZADO')
        }
        console.log('retornobusca RDO', res.data.result)

        BuscarLista()
        BuscarLista1()

    };


    async function BuscarLista() {

        const res = await axios.get(Conexao.api + 'ListaDinamica_Rdo.php?relatorioDObra=' + relatorioDObra);
        if (res.data.success) {
            setClientes(res.data.result)

        } else {
            setClientes([])
            alert('NÃO REALIZADO')
        }

        console.log('Lista1  ' + res.data.success)

    };
    async function BuscarLista1() {

        const res = await axios.get(Conexao.api + 'ListaDinamica1_Rdo.php?relatorioDObra=' + relatorioDObra);
        if (res.data.success) {

            setClientes1(res.data.result)

        } else {
            setClientes1([])
            alert('NÃO REALIZADO')
        }

        console.log('Lista2  ' + res.data.success)

    };



    async function SalvarRdo() {
        const obj = {
            relatorioDObra, solicitante, escopo, localizacao, empresa, numeroContrato, propostocontrato, fiscal, datadordo, equipamento, tempomanha, tempotarde, temponoite
        };

        const res = await axios.post(Conexao.api + 'SalvarRdoWeb.php', obj);

        console.log('SalvarLista', obj)

        if (res.data.success === true) {
            alert('RDO Atualizado Sucesso!')
        }


    };


    async function SalvarListaD(id) {
        const obj = {
            relatorioDObra, confirmacaoId, descricaoequipamento, quantidadeequipamento, descricaoefetivo, quantidadeefetivo
        };

        const res = await axios.post(Conexao.api + 'SalvarListaDinamicaRdo.php', obj);

        console.log('lista Dinamica', obj)

        if (res.data.success === true) {
            setShow(false);
            BuscarLista()
        }

    };

    async function SalvarListaD1(id) {
        const obj = {
            relatorioDObra, confirmacaoId, periodoInicio, periodoFim, codigoAtividade, descricaoAtividade, idtabela, quantidadeTabela, unidadeTabela, observacaoTabela
        };

        const res = await axios.post(Conexao.api + 'SalvarListaDinamica1Rdo.php', obj);

        console.log('lista Dinamica', obj)

        if (res.data.success === true) {
            setShow1(false);
            BuscarLista1()
        }

    };



    function LimpacampoADD() {
        setConfirmacaoId(0);
        setDescricaoequipamento("");
        setDescricaoefetivo("");
        setQuantidadeequipamento("");
        setQuantidadeefetivo("");
        handleShow()

        // alert('Excluir o item:'+ id)
    }

    function LimpacampoADD1() {
        setConfirmacaoId(0);
        setPeriodoInicio("");
        setPeriodoFim("");
        setCodigoAtividade("");
        setDescricaoAtividade("");
        setIdtabela("");
        setQuantidadeTabela("");
        setUnidadeTabela("");
        setObservacaoTabela("");

        handleShow1()

        // alert('Excluir o item:'+ id)
    }



    function confirmDeleteUser(id) {
        setConfirmacaoId(id);
        setConfirmacao(true);


        // alert('Excluir o item:'+ id)
    }

    function confirmDeleteUser1(id) {
        setConfirmacaoId1(id);
        setConfirmacao1(true);


        // alert('Excluir o item:'+ id)
    }


    function confirmEdite(id, EquiDescricao, EquiQuantidade, EfeDescricao, EfeQuantidade) {
        setConfirmacaoId(id);

        setDescricaoequipamento(EquiDescricao)
        setQuantidadeequipamento(EquiQuantidade)

        setDescricaoefetivo(EfeDescricao)
        setQuantidadeefetivo(EfeQuantidade)


        handleShow()

    }
    function confirmEdite1(id, Inicio, Fim, Codigo, Atividade, itabela, Quantidade, Unidade, Observacao) {
        setConfirmacaoId(id);

        setPeriodoInicio(Inicio)
        setPeriodoFim(Fim)

        setCodigoAtividade(Codigo)
        setDescricaoAtividade(Atividade)

        setIdtabela(itabela)
        setQuantidadeTabela(Quantidade)

        setUnidadeTabela(Unidade)
        setObservacaoTabela(Observacao)

        handleShow1()





    }
    async function deleteUser(confirmacaoId) {

        const res = await axios.get(Conexao.api + 'ExcluirListaDinamica_Rdo.php?id=' + confirmacaoId);
        if (res.data.success === true) {
            setConfirmacao(false);
            BuscarLista()
        }
    }

    async function deleteUser1(confirmacaoId1) {

        const res = await axios.get(Conexao.api + 'ExcluirListaDinamica_1Rdo.php?id=' + confirmacaoId1);
        if (res.data.success === true) {
            setConfirmacao1(false);
            BuscarLista1()
        }
    }




    return (<div>
        <Navbar />
        <div className='titulolaboratorio container-fluid'>
            <h1 className='texttitulo'>RELATÓRIO DIÁRIO DE OBRA</h1>
        </div>



        <body class="container text-center ">

            <div class="container text-center ">
                <div class="row d-flex align-items-end justify-content-center p-2">

                    <div class="col-md-3 md-0">

                        <h6>Relatorio Diario de Obra:</h6>
                        <input name='relatorioDObra' id='relatorioDObra' className='form-control text-center' value={relatorioDObra} onChange={(e) => setRelatorioDObra(e.target.value)} ></input>

                        <div class="col-4">
                            <div className="btn btn-outline-success-center " type="submit"><button onClick={(e) => BuscarRdo(e)} class="btnlogin me-md-2" > Buscar</button>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </body>

        <form className="container-fluid ">
            <br />
            <br />

            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">
                        <h6>DADOS DO EMPREENDIMENTO</h6>
                        <br />
                        <div class="col-4">
                            <h7>Área Solicitante:</h7>
                            <input name='solicitante' id='solicitante' className='form-control text-center colorInput ' disabled={habilitar} value={solicitante} onChange={(e) => setSolicitante(e.target.value)} ></input>
                        </div>

                        <div class="col-4">
                            <h7>Escopo:</h7>
                            <input name='escopo' id='escopo' className='form-control text-center colorInput ' disabled={habilitar} value={escopo} onChange={(e) => setEscopo(e.target.value)} ></input>
                        </div>


                        <div class="col-4">
                            <h7>LOCAL:</h7>
                            <input name='localizacao' id='localizacao' className='form-control text-center colorInput ' disabled={habilitar} value={localizacao} onChange={(e) => setLocalizacao(e.target.value)} ></input>
                        </div>

                    </div>
                </div>
            </body>
            <br />



            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">



                        <div class="col-6">
                            <h7>Razão Social:</h7>
                            <input name='empresa' id='empresa' className='form-control text-center colorInput ' disabled={habilitar} value={empresa} onChange={(e) => setEmpresa(e.target.value)} ></input>
                        </div>

                        <div class="col-6">
                            <h7>CONTRATO Nº:</h7>
                            <input name='numeroContrato' id='numeroContrato' className='form-control text-center colorInput ' disabled={habilitar} value={numeroContrato} onChange={(e) => setNumeroContrato(e.target.value)} ></input>
                        </div>

                    </div>
                </div>
            </body>

            <br />

            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">


                        <div class="col-6">
                            <h7>Proposto no Contrato:</h7>
                            <input name='propostocontrato' id='propostocontrato' className='form-control text-center colorInput ' disabled={habilitar} value={propostocontrato} onChange={(e) => setPropostocontrato(e.target.value)} ></input>
                        </div>

                        <div class="col-6">
                            <h7>Fiscal do Contrato:</h7>
                            <input name='fiscal' id='fiscal' className='form-control text-center colorInput ' disabled={habilitar} value={fiscal} onChange={(e) => setFiscal(e.target.value)} ></input>
                        </div>


                    </div>
                </div>
            </body>

            <br />

            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">



                        <div class="col">
                            <h7>DATA EXECUÇÃO:</h7>
                            <input name='datadordo' id='datadordo' type='date' className='form-control text-center colorInput ' disabled={habilitar} format='YYYY/MM/DD' value={datadordo} onChange={(e) => setDatadordo(e.target.value)} ></input>
                        </div>


                        <div class="col">
                            <h7>Equipamento:</h7>
                            <input name='equipamento' id='equipamento' className='form-control text-center colorInput ' disabled={habilitar} value={equipamento} onChange={(e) => setEquipamento(e.target.value)} ></input>
                        </div>



                    </div>
                </div>
            </body>

            <br />
            <br />
            <body  >
                <div class="container text-center">
                    <div class="row align-items-start">


                        <h6>Condições Do Tempo:</h6>
                        <br />
                        <div class="col">
                            <h7>Manhã:</h7>
                            <input name='tempomanha' id='tempomanha' className='form-control text-center colorInput ' disabled={habilitar} value={tempomanha} onChange={(e) => setTempomanha(e.target.value)} ></input>
                        </div>

                        <div class="col">
                            <h7>Tarde:</h7>
                            <input name='tempotarde' id='tempotarde' className='form-control text-center colorInput ' disabled={habilitar} value={tempotarde} onChange={(e) => setTempotarde(e.target.value)} ></input>
                        </div>

                        <div class="col">
                            <h7>Noite:</h7>
                            <input name='temponoite' id='temponoite' className='form-control text-center colorInput ' disabled={habilitar} value={temponoite} onChange={(e) => setTemponoite(e.target.value)} ></input>
                        </div>

                    </div>
                </div>
            </body>
            <br />
            <br />
            <br />

        </form>


        <div class="container text-center">
            <div class="row align-items-start">



                <ListaDinamica_1RdoPesquisamineral arrayClientes={clientes} clickDelete={confirmDeleteUser} editar={confirmEdite} />
                <div className="btn btn-outline-success-center " type="submit">
                    <button onClick={LimpacampoADD} class="btnlogin  me-md-2  " disabled={habilitar} hidden={bnthabilitar} > Adicionar </button>

                </div>
                {
                    confirmacao ? <SweetAlert
                        warning
                        showCancel
                        showCloseButton
                        confirmBtnText="Sim"
                        confirmBtnBsStyle="danger"
                        cancelBtnText="Não"
                        cancelBtnBsStyle="light"
                        title="Exclusão"
                        onConfirm={() => deleteUser(confirmacaoId)}
                        onCancel={() => setConfirmacao(false)}
                        reverseButtons={false}
                    >
                        Deseja excluir o Item selecionado?
                    </SweetAlert> : null}

                <Modal show={show} onHide={handleClose}  >

                    <Modal.Header closeButton>
                        <Modal.Title>CORREÇÃO BOLETIM SONDAGEM:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                        <Form>

                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>ID SELECIONADO PARA MODIFICAÇÃO:</Form.Label>
                                <Form.Control
                                    type="text" disabled={true}
                                    onChange={(e) => { setConfirmacaoId(e.target.value) }}
                                    value={confirmacaoId}


                                />
                            </Form.Group>



                            <Form.Label>Descrição Equipamento:</Form.Label>
                            <select className=' form-select  text-center colorInput ' onChange={(e) => setDescricaoequipamento(e.target.value)} value={descricaoequipamento} >
                                <option selected value="...">Selecione...</option>
                                <option value="Sonda Rotativa">Sonda Rotativa</option>
                                <option value="Trípe de Sondagem">Trípe de Sondagem</option>
                                <option value="Veiculo Administrativo">Veiculo Administrativo</option>
                                <option value="Caminhão Prancha">Caminhão Prancha</option>
                                value={descricaoequipamento}
                            </select>


                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Quantidade Equipamento:</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setQuantidadeequipamento(e.target.value) }}
                                    value={quantidadeequipamento}

                                />
                            </Form.Group>                         

                            <Form.Label>Descrição Equipamento:</Form.Label>
                            <select className=' form-select  text-center colorInput ' onChange={(e) => setDescricaoefetivo(e.target.value)} value={descricaoefetivo} >
                                <option selected value="...">Selecione...</option>
                                <option value="Técnico Mineração">Técnico Mineração</option>
                                <option value="Laboratorista">Laboratorista</option>
                               
                                value={descricaoefetivo}
                            </select>
               

                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Quantidade Efetivo:</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setQuantidadeefetivo(e.target.value) }}
                                    value={quantidadeefetivo}

                                />
                            </Form.Group>


                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>Fechar</Button>
                        <Button variant="primary" onClick={(e) => (SalvarListaD(e))}>Salvar </Button>


                    </Modal.Footer>
                </Modal>


            </div>
        </div>

        <br />
        <br />

        <div class="container text-center">
            <div class="row align-items-start">



                <ListaDinamica_2RdoPesquisamineral arrayClientes1={clientes1} clickDelete1={confirmDeleteUser1} editar1={confirmEdite1} />
                <div className="btn btn-outline-success-center " type="submit">
                    <button onClick={LimpacampoADD1} class="btnlogin  me-md-2  " disabled={habilitar} hidden={bnthabilitar} > Adicionar </button>

                </div>
                {
                    confirmacao1 ? <SweetAlert
                        warning
                        showCancel
                        showCloseButton
                        confirmBtnText="Sim"
                        confirmBtnBsStyle="danger"
                        cancelBtnText="Não"
                        cancelBtnBsStyle="light"
                        title="Exclusão"
                        onConfirm={() => deleteUser1(confirmacaoId1)}
                        onCancel={() => setConfirmacao1(false)}
                        reverseButtons={false}
                    >
                        Deseja excluir o Item selecionado?
                    </SweetAlert> : null}

                <Modal show={show1} onHide={handleClose1}  >

                    <Modal.Header closeButton>
                        <Modal.Title>CORREÇÃO BOLETIM SONDAGEM:</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>


                        <Form>

                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>ID SELECIONADO PARA MODIFICAÇÃO:</Form.Label>
                                <Form.Control

                                    type="text" disabled={true}
                                    onChange={(e) => { setConfirmacaoId(e.target.value) }}
                                    value={confirmacaoId}
                                />
                            </Form.Group>

                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Inicio:</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setPeriodoInicio(e.target.value) }}
                                    value={periodoInicio}

                                />
                            </Form.Group>

                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Fim:</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setPeriodoFim(e.target.value) }}
                                    value={periodoFim}

                                />
                            </Form.Group>




                            <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                                <Form.Label>Descricão Atividade:</Form.Label>
                                <Select

                                    options={ListaDescricaoAtividade}
                                    onChange={item => {
                                        setDescricaoAtividade(item.value);

                                    }} />
                            </Form.Group>



                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>ID:</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setIdtabela(e.target.value) }}
                                    value={idtabela}

                                />
                            </Form.Group>

                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Quantidade:</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setQuantidadeTabela(e.target.value) }}
                                    value={quantidadeTabela}

                                />
                            </Form.Group>

                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Unidade:</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setUnidadeTabela(e.target.value) }}
                                    value={unidadeTabela}

                                />
                            </Form.Group>






                            <Form.Group
                                className="mb-3"
                                controlId="exampleForm.ControlTextarea1"
                            >
                                <Form.Label>Observação:</Form.Label>
                                <Form.Control
                                    type="text"
                                    onChange={(e) => { setObservacaoTabela(e.target.value) }}
                                    value={observacaoTabela}

                                />
                            </Form.Group>








                        </Form>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose1}>Fechar</Button>
                        <Button variant="primary" onClick={(e) => (SalvarListaD1(e))}>Salvar </Button>


                    </Modal.Footer>
                </Modal>


            </div>
        </div>


        <br />
        <br />

        <div class="row d-flex align-items-end justify-content-end ">
            <div class="col-4">
                <div className="btn btn-outline-success-center " type="submit">
                    <button onClick={(e) => (SalvarRdo(e))} class="btnlogin  me-md-2  " hidden={bnthabilitar} Button > Salvar </button>
                </div>
            </div>
        </div>

















    </div>
    )



}

export default RDO_PesquisaMineral;